module.exports = __webpack_public_path__ + "media/unipod/icon-convenience-19bf1bfb.svg";